module.exports = __webpack_public_path__ + "assets/images/relogio_2a46e64aab36ad2033601df48dd1cacd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/piramide/relogio.png
// module id = 214
// module chunks = 0